module.exports = __webpack_public_path__ + "static/media/shield-3.c4ab7555.glb";